import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import FormattedPrice from '../../components/FormattedPrice';
import Quantity from '../../components/Quantity';
import {getItemPrice} from '../../helpers/common';
import {withTranslation} from 'react-i18next';
import {addToOrder, setCurrentOrderItem} from '../../redux/actions/orderActions';
import {selectItem, loadMenuItemSupplements, loadBusinessLunchInfo} from '../../redux/actions/menuActions';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {hideLoading, showLoading} from '../../redux/actions/loadingActions';
import PizzaPart from '../../components/PizzaPart';
import {useHistory} from 'react-router-dom';
import BlItemCartDetails from './BlItemCartDetails';
import IPosModal from '../../IPosModal';

const CartItem = ({
                    cartItem, t, selectItem, addToOrder, menuItemTypes,
                    editable = true, showLoading, hideLoading, currentLanguageId,
                    branchInfo, setCurrentOrderItem, loadBusinessLunchInfo, loadMenuItemSupplements
                  }) => {
  const history = useHistory();

  const openModal = async () => {
    if (!editable) {
      return;
    }

    showLoading();
    selectItem(cartItem.menuItem);
    setCurrentOrderItem(Object.assign({}, cartItem));

    const isBusinessLunch = cartItem.menuItem.is_business_lunch_flg === 1 || cartItem.menuItem.is_kiosk_item_flg === 1;
    if (isBusinessLunch) {
      loadBusinessLunchInfo(cartItem.menuItem.menu_item_id).then((blData) => {
        hideLoading();
        openAddBLItemModal(cartItem.menuItem.menu_item_id, blData);
      });
    } else {
      loadMenuItemSupplements(cartItem.menuItem.menu_item_id).then(([supplements, instructions]) => {
        hideLoading();
        IPosModal.addItemModal(
          {
            menuItem: cartItem.menuItem,
            currentOrderItem: cartItem,
            t: t,
            // menuItemTypes: menuItemTypes,
            selectedItemSupplements: supplements,
            itemInstructions: instructions,
            menuItemTypes: menuItemTypes,
            branchInfo: branchInfo,
            onOk: (orderItem) => {
              addToOrder(orderItem);
            },
            onClose: () => {},
          },
          {}
        );
      });
    }

    // selectItem(cartItem.menuItem).then(async ([supplements, instructions]) => {
    //   hideLoading();

    //   setCurrentOrderItem(Object.assign({}, cartItem));
    //   const isBusinessLunch = cartItem.menuItem.is_business_lunch_flg === 1;

    //   if (isBusinessLunch) {
    //     //history.push(`/${branchInfo.branch_guid_code}/add_bl_item`);
    //     // IPosModal.testModal({
    //     //     menuItem: cartItem.menuItem,
    //     //     currentOrderItem: cartItem,            
    //     //     menuItemTypes: menuItemTypes,
    //     //     onOk: (orderItem) => { addToOrder(orderItem); }, 
    //     //     onClose: () => { },
    //     //     t: t
    //     // }, {});
    //     openAddBLItemModal(cartItem.menuItem.menu_item_id)
    //   } 
    //   else {
    //     IPosModal.addItemModal({
    //       menuItem: cartItem.menuItem,
    //         currentOrderItem: cartItem,
    //         t: t,
    //         // menuItemTypes: menuItemTypes,
    //         selectedItemSupplements: await supplements,
    //         itemInstructions: await instructions,
    //         menuItemTypes: menuItemTypes,
    //         branchInfo : branchInfo, 
    //         onOk: (orderItem) => {
    //           addToOrder(orderItem);
    //         }, onClose: () => {

    //         }
    //       }, {});
    //   }
    // });
  };

  const openAddBLItemModal = async (businessLunchId, blData) => {
    //await loadBusinessLunchInfo(businessLunchId).then((blData) => {
      IPosModal.testModal(
        {
          menuItem: cartItem.menuItem,
          currentOrderItem: cartItem,
          selectedBusinessLunch: blData,
          loadMenuItemSupplements: loadMenuItemSupplements,
          currentLanguageId: currentLanguageId,
          branchInfo: branchInfo,
          menuItemTypes: menuItemTypes,
          t,
          onOk: (orderItem) => {
            addToOrder(orderItem);
          },
        },
        {}
      );
    //});
  }; 



  return (
    <div className="cart-item">
      <div className="cart-item-info main-item">
        <div className="cart-item-name">{cartItem.menuItem.item_name}</div>
        <div className="cart-time-price">
          <span className="amount"><FormattedPrice price={ getItemPrice(cartItem) } /> </span>
        </div>
      </div>
      {cartItem.menuItem.is_business_lunch_flg === 1 || cartItem.menuItem.is_kiosk_item_flg === 1 && (
        <BlItemCartDetails t={ t } blItems={ cartItem.lunchItems } />
      )}
      {cartItem.supplements.length > 0 &&
        cartItem.supplements.map((supplement, index) => (
          <div className="cart-item-info supplements-info" onClick={ openModal }>
            <div className="cart-item-name">
              <span> <PizzaPart part={ supplement.orderItem.pizza_item_part } /> {supplement.menuItem.item_name} </span>
            </div>

            {supplement.menuItem.web_price > 0 && (
              <div className="cart-time-price">
                <span className="amount"><FormattedPrice price={ getItemPrice(supplement) } /> </span>
              </div>
            )}
          </div>
        ))
      }

      {cartItem.instructions.length > 0 &&
        <div className="cart-item-info supplements-info" onClick={ openModal }>
          <div
            className="cart-item-name">{cartItem.instructions.map((instruction, index) => (instruction.menuItem.item_name)).join(', ')}</div>
        </div>
      }

      {cartItem.freeInstruction.trim() !== '' && (
        <div className="cart-item-info">
          <div className="cart-item-name">{cartItem.freeInstruction}</div>
        </div>
      )
      }

      {editable && (
        <div className="cart-item-action">
          { cartItem.editAllowed && (
              <div className={ 'edit_item_block' } onClick={ openModal }>
                  <FontAwesomeIcon icon="pen" />
              </div>
          ) }

          <Quantity orderItem={ cartItem } t={ t } />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    menuItemTypes,
    branchInfo,
    currentLanguageId
  } = state;

  return {
    menuItemTypes,
    branchInfo
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addToOrder,
      selectItem,
      showLoading, hideLoading,
      setCurrentOrderItem,
      loadMenuItemSupplements,
      loadBusinessLunchInfo
    },
    dispatch,
  );

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CartItem));
